import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFilePng = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 217,
	viewBox: "0 0 165 217",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M139.67 49.25C134.202 49.2421 128.96 47.0657 125.095 43.1982C121.229 39.3308 119.055 34.0881 119.05 28.62V1.85821e-06H26.9203C23.3856 -0.00131167 19.8851 0.693768 16.619 2.04553C13.353 3.3973 10.3853 5.37922 7.8854 7.87818C5.38552 10.3771 3.40245 13.3441 2.04947 16.6096C0.696487 19.8751 0.000150283 23.3752 0.000150527 26.9099V189.09C-0.0116969 192.632 0.675913 196.142 2.02359 199.418C3.37126 202.694 5.3526 205.671 7.85367 208.18C10.3547 210.688 13.3264 212.678 16.5983 214.036C19.8702 215.393 23.378 216.091 26.9203 216.09H137.52C144.657 216.09 151.502 213.255 156.548 208.208C161.595 203.162 164.43 196.317 164.43 189.18V49.25H139.67Z",
				fill: "#005FAD"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.43 49.25H139.67C134.202 49.2421 128.96 47.0657 125.094 43.1982C121.229 39.3308 119.055 34.0881 119.05 28.62V0L164.43 49.25Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.7002 66.72H40.9502V80.47H54.7002V66.72Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.46 80.47H54.71V94.22H68.46V80.47Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.21 66.72H68.46V80.47H82.21V66.72Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.96 80.47H82.21V94.22H95.96V80.47Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.72 66.72H95.9697V80.47H109.72V66.72Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.48 80.47H109.73V94.22H123.48V80.47Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.7002 94.2H40.9502V107.95H54.7002V94.2Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.46 107.95H54.71V121.7H68.46V107.95Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.21 94.2H68.46V107.95H82.21V94.2Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.96 107.95H82.21V121.7H95.96V107.95Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.72 94.2H95.9697V107.95H109.72V94.2Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.48 107.95H109.73V121.7H123.48V107.95Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.7002 121.81H40.9502V135.56H54.7002V121.81Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.46 135.56H54.71V149.31H68.46V135.56Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.21 121.81H68.46V135.56H82.21V121.81Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.96 135.56H82.21V149.31H95.96V135.56Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.72 121.81H95.9697V135.56H109.72V121.81Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.48 135.56H109.73V149.31H123.48V135.56Z",
			fill: "#005FAD"
		})
	]
});
export default SvgIconFilePng;
